<header class="header" [ngClass]="{'header--banner': auth}" [class.header--fixed]="isFixed" [class.is-visible]="isHidden">
  <div class="header__inner">
    <div class="container">
      <div class="header__row">
        <a *ngIf="!auth" href="#" class="header__logo">
          <img ngSrc="/assets/images/svg/logoMainDark.svg" alt="НДВ супермаркет недвижимости" width="222" height="48"
               priority="high">
          <img ngSrc="/assets/images/svg/logoMainMobile.svg" alt="НДВ супермаркет недвижимости" class="__new__header__top-logo__logo-mobile" width="150" height="32">
        </a>
        <div *ngIf="auth" class="header__login">
          <a href="#" class="header__login-link" matTooltip="Личный кабинет. Инструменты, предоставляющие пользователям и компаниям возможность управлять своими бизнес-процессами и анализировать данные по маркетингу и продажам" matTooltipClass="tooltip-popover">
            <app-ui-icon [name]="'icon-avatar'" [width]="37" [height]="36"></app-ui-icon>
          </a>
        </div>
        <nav class="header__nav" [class]="{'active': menuVisible}">
          <div class="header__link" (click)="openSelectCity()" matTooltip="Выбор локации. Вы можете выбрать город или область для отображения каталога или новостей" matTooltipClass="tooltip-popover">
            <app-ui-icon [name]="'icon-local'" [width]="16"></app-ui-icon>
            <span>Москва</span>
          </div>
          <a class="header__link" href="#" matTooltip="Обратиться в поддержку. Наша служба поддержки ответит на все интересующие вас вопросы: финансовые, технические и т.д." matTooltipClass="tooltip-popover">
            <app-ui-icon [name]="'icon-help'" [width]="16"></app-ui-icon>
            <span>Обратиться в поддержку</span>
          </a>
          <a href="#" class="header__link ml-auto" matTooltip="Каталог. Мы собрали самые актуальные предложения недвижимости. Вам доступны квартиры, дома, коммерческие помещения и земельные участки — на любой вкус и бюджет." matTooltipClass="tooltip-popover">
            Каталог
          </a>
          <a href="#" class="header__link">
            Клиенты
          </a>
          <a href="#" class="header__link">
            Инструменты
          </a>
          <a href="#" class="header__link">
            Мои квартиры
            <span class="header__badge">+</span>
          </a>
        </nav>
        <div class="header__tools">
          <div class="header__tools-item">
            <a href="#" class="header__tool">
              <app-ui-icon [name]="'icon-heart'" [width]="20" [height]="18"></app-ui-icon>
            </a>
          </div>
          <div class="header__tools-item header__tools-item--btn">
            <app-button color="primary" extended class="header__tool-btn square md">
              <app-ui-icon class="xl:hidden" [name]="'icon-validate'" [width]="24" [height]="24"></app-ui-icon>
              <span class="hidden xl:block">Проверить на уникальность</span>
            </app-button>
          </div>
          <div class="header__tools-item header__tools-item--menu">
            <a href="#" class="header__tool">
              <app-ui-icon [name]="'icon-menu'" [width]="30" [height]="20"></app-ui-icon>
            </a>
          </div>
        </div>
        <app-button-toggle
          class="header__btn-toggle"
          [active]="menuVisible"
          (toggleMenu)="toggleMenu()"
        ></app-button-toggle>
      </div>
    </div>
  </div>
</header>
